export class AdvisingAbnormalOperationUserBean {
  userName: string;
  operationDate: Date;

  constructor() {
    this.userName = "";
    this.operationDate = new Date();
  }
}
